import { EllipsisOutlined } from '@ant-design/icons';
import { Button, Dropdown, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import type { FC } from 'react';
import type { MenuProps } from 'antd';
import type { Pod } from '../../types';

interface IPodRowActionsProps {
  pod: Pod;
  onEdit?: (pod: Pod) => void;
  onActivate?: (pod: Pod) => void;
  onInactivate?: (pod: Pod) => void;
  onDelete?: (pod: Pod) => void;
  loading?: boolean;
}

const PodRowActions: FC<IPodRowActionsProps> = ({
  pod,
  onEdit,
  onActivate,
  onInactivate,
  onDelete,
  loading = false,
}) => {
  const { t } = useTranslation();

  const isInactive = pod.status === 'inactive';

  const items: MenuProps['items'] = [
    {
      key: 'edit',
      'data-cy': 'dropdown-edit-item',
      label: isInactive ? (
        <Tooltip title={t('labels.inactivePodCannotBeEdited')}>
          <span>{t('labels.edit')}</span>
        </Tooltip>
      ) : (
        t('labels.edit')
      ),
      onClick: () => {
        if (!isInactive) onEdit?.(pod);
      },
      disabled: loading || isInactive,
    },
    isInactive
      ? {
          key: 'activate',
          'data-cy': 'dropdown-activate-item',
          label: t('labels.activate'),
          onClick: () => onActivate?.(pod),
          disabled: loading,
        }
      : {
          key: 'inactivate',
          'data-cy': 'dropdown-inactivate-item',
          label: t('labels.inactivate'),
          onClick: () => onInactivate?.(pod),
          disabled: loading,
        },
    {
      key: 'delete',
      'data-cy': 'dropdown-delete-item',
      label: t('labels.delete'),
      onClick: () => onDelete?.(pod),
      danger: true,
      disabled: loading,
    },
  ].filter(Boolean);

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      placement="bottomRight"
      overlayStyle={{ minWidth: '12.5rem' }}
    >
      <Button
        type="text"
        icon={<EllipsisOutlined />}
        aria-label={t('labels.podActions')}
        data-cy="pod-list__actions-btn"
      />
    </Dropdown>
  );
};

export default PodRowActions;
